'use client';

import React from 'react';
import { Metadata } from 'next';
import Layout from '@/components/layout/error-page';
import ErrorPage from '@/components/error-page';
import { DEFAULT_VIEWPORT } from '@/constants/common';
import { sendError } from '@/api/tanzhi';
import { handleChunkError } from '@/utils/chunk-error-handler';

export const metadata: Metadata = {
  title: '抱歉，出错了 - 谈职',
  viewport: DEFAULT_VIEWPORT,
};

const BOT_KEYWORDS = [
  'bot',
  'spider',
  'crawler',
  'curl',
  'python',
  'java',
  'wget',
  'perl',
  'ruby',
  'go',
  'node',
];

const Error = (props: {
  error: Error & { digest?: string };
  reset: () => void;
}) => {
  const { error } = props;

  React.useEffect(() => {
    const { name, message, stack, digest } = error;
    const ua = navigator.userAgent.toLowerCase();
    if (BOT_KEYWORDS.some((keyword) => ua.includes(keyword))) return;

    if (name && message && stack) {
      if (
        name === 'ChunkLoadError' &&
        !sessionStorage.getItem('chunk-reloaded')
      ) {
        sessionStorage.setItem('chunk-reloaded', '1');
        handleChunkError(error).then(() => window.location.reload());
        return;
      }
      sendError({
        name,
        message: message + (digest || ''),
        stack,
        url: window.location.href,
      }).then();
    }
  }, [error]);

  return (
    <Layout needViewPort={true}>
      <ErrorPage errorCode={500} errorText="抱歉，出错了！" />
    </Layout>
  );
};

export default Error;
